module.exports = __webpack_public_path__ + "static/assets/37c5b4492799945cc51775f550ab219f.png";